module.exports = __webpack_public_path__ + "static/media/Arrow_down_outline.f170c98f.svg";